export default __webpack_public_path__ + "static/media/img-03.8beb6eec.png";